import { queryOptions } from "@tanstack/react-query";
import { campaignTrackerAPIClient } from "./campaignTrackerAPIClient";

export const TRACKER_KEYS = {
  all: ["campaignTracker"] as const,
  list: () => ["campaignTracker", "list"] as const,
  detail: (campaignId: string) => ["campaignTracker", "detail", campaignId] as const,
  history: (campaignId: string, offset: number) => ["campaignTracker", "history", campaignId, offset] as const,
};

export const TRACKER_QUERIES = {
  list: () => queryOptions({ queryKey: TRACKER_KEYS.list(), queryFn: () => campaignTrackerAPIClient.list(), staleTime: 30_000 }),
  detail: (campaignId: string) =>
    queryOptions({ queryKey: TRACKER_KEYS.detail(campaignId), queryFn: () => campaignTrackerAPIClient.detail(campaignId), staleTime: 0 }),
  history: (campaignId: string, offset: number) =>
    queryOptions({
      queryKey: TRACKER_KEYS.history(campaignId, offset),
      queryFn: () => campaignTrackerAPIClient.history(campaignId, offset),
      staleTime: 0,
    }),
};
